import type { HubCacheSseEvent } from "./hubCacheChannels";
import type { HubDbPoolHolderSnapshot } from "./slowRequestBanner";

export type HubLiveSseEvent =
  | { kind: "connected"; channels: string[] }
  | ({ kind: "cache" } & HubCacheSseEvent)
  | { kind: "lifecycle"; phase: "server_draining" }
  | { kind: "pool"; phase: "connected" | "holders"; snapshot: HubDbPoolHolderSnapshot };

export function parseHubLiveSseDataLine(line: string): HubLiveSseEvent | null {
  if (!line.startsWith("data: ")) {
    return null;
  }
  const payload = line.slice("data: ".length).trim();
  if (payload === "") {
    return null;
  }
  try {
    const parsed: unknown = JSON.parse(payload);
    if (parsed == null || typeof parsed !== "object" || Array.isArray(parsed)) {
      return null;
    }
    const record = parsed as Record<string, unknown>;
    if (record.kind === "connected" && Array.isArray(record.channels)) {
      return {
        kind: "connected",
        channels: record.channels.filter((channel): channel is string => typeof channel === "string"),
      };
    }
    if (record.kind === "lifecycle" && record.phase === "server_draining") {
      return { kind: "lifecycle", phase: "server_draining" };
    }
    if (record.kind === "pool" && (record.phase === "connected" || record.phase === "holders")) {
      return parsed as HubLiveSseEvent;
    }
    if (record.kind === "cache" && typeof record.phase === "string" && typeof record.channel === "string") {
      return parsed as HubLiveSseEvent;
    }
    return null;
  } catch {
    return null;
  }
}
